import { ReferenzBahnstruktur } from './ReferenzBahnstruktur';
import { ReferenzBildung } from './ReferenzBildung';
import { ReferenzFinanz } from './ReferenzFinanz';
import { ReferenzForschung } from './ReferenzForschung';
import { ReferenzIndustrie } from './ReferenzIndustrie';
import { ReferenzKultur } from './ReferenzKultur';
import { ReferenzSozialbereich } from './ReferenzSozialbereich';
import { ReferenzUmwelt } from './ReferenzUmwelt';
import { ReferenzSonstiges } from './ReferenzSonstiges';

export const ReferenzenController = ({ referenceItem }) => {
  const getIllustration = () => {
    switch (referenceItem.title) {
      case 'Bahnstruktur':
        return <ReferenzBahnstruktur />;
      case 'Bildung':
        return <ReferenzBildung />;
      case 'Finanz':
        return <ReferenzFinanz />;
      case 'Forschung':
        return <ReferenzForschung />;
      case 'Industrie':
        return <ReferenzIndustrie />;
      case 'Kultur':
        return <ReferenzKultur />;
      case 'Sozialbereich':
        return <ReferenzSozialbereich />;
      case 'Umwelt':
        return <ReferenzUmwelt />;
      case 'Sonstiges':
        return <ReferenzSonstiges />;
      default:
        return '';
    }
  };

  return <>{getIllustration()}</>;
};
